<script setup lang="ts">
import { LoadStatus } from "@/models/frontend-only/LoadStatus";

const store = useSongStore();
</script>

<template>
  <section>
    <SectionTitle :placeholder="store.placeholderNotLoaded">{{
      $t("S.LIT_Authors")
    }}</SectionTitle>
    <div v-if="store.song">
      <template
        v-for="(a, i) of store.song.authors || []"
        :key="i"
      >
        <router-link
          :to="`/search/results?${a.searchQuery}`"
          class="authors link"
          >{{ a.label }}</router-link
        >
        <span v-if="i !== store.song!.authors.length - 1">, </span>
      </template>
    </div>
  </section>
</template>

<style scoped lang="postcss"></style>
